<script setup lang="ts">
import type { PropType } from 'vue';

import { ROUTE_NAMES } from '~/constants/routes';
import type { DirectSaleItemEntityWithSellingMethod } from '~/types/sale.type';

// PROPS
const { directSale } = defineProps({
    directSale: { type: Object as PropType<DirectSaleItemEntityWithSellingMethod>, required: true },
});

// COMPOSABLES
const { tt } = useTypedI18n();
const { data: authData } = useAuthUtils();
const route = useRoute();
const localePath = useLocalePath();
const { trackDsNegotiationGoToNegotiation } = useTracking();

// DATA
const isBuyer = computed(() => directSale.sellerCompanyId !== authData.value?.user?.companyId);

const label = computed(() => tt(isBuyer.value ? 'directSaleNegotiation.buyerGoToNegotiation' : 'directSaleNegotiation.sellerGoToNegotiation'));

const routeTo = computed(() => ({ name: ROUTE_NAMES.DIRECT_SALE_DETAIL_NEGOTIATION, params: route.params }));

// METHODS
const onBuyerClick = (): void => {
    trackDsNegotiationGoToNegotiation(true);
};

const onSellerClick = (): void => {
    trackDsNegotiationGoToNegotiation(false);
};
</script>

<template>
    <NuxtLinkLocale v-if="isBuyer" class="text-center text-xs font-semibold underline md:text-base" :to="routeTo" @click="onBuyerClick">
        {{ label }}
    </NuxtLinkLocale>

    <UButton
        v-else
        size="lg"
        variant="solid"
        :ui="buttonResponsiveSizeUi('lg', 'xl')"
        :label="label"
        block
        :to="localePath(routeTo)"
        @click="onSellerClick"
    />
</template>
